import axios from "axios";
import { getApiBaseUrl } from "services/apiConfig";

export const pingBackend = async () => {
  try {
    await axios.get(`${getApiBaseUrl()}/ping`);
    return true;
  } catch (error) {
    console.error("Backend check failed:", error);
    return false;
  }
};

export const pingDatabase = async () => {
  try {
    await axios.get(`${getApiBaseUrl()}/db-ping`);
    return true;
  } catch (error) {
    console.error("Database check failed:", error);
    return false;
  }
};
